import { Component } from '@angular/core';
import { NgFor } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import {
  ImageTextCard,
  ImageTextCardWrapperComponent,
} from '../../shared/components/image-text-card-wrapper/image-text-card-wrapper.component';
@Component({
  selector: 'app-services',
  standalone: true,
  imports: [NgFor, TranslatePipe, ImageTextCardWrapperComponent],
  templateUrl: './services.component.html',
  styleUrl: './services.component.scss',
})
export class ServicesComponent {
  bgColors: Array<string> = [
    '#1E3722',
    '#31443A',
    '#37473F',
    '#2F3A54',
    '#243C28',
    '#172219',
  ];
  heroImage = 'assets/images/services-hero-image.png';
  sectionTitle = 'services-page.title';
  services: Array<ImageTextCard> = [
    {
      icon: 'assets/images/services/scrum-services.png',
      title: 'services-page.services.scrum.title',
      description: 'services-page.services.scrum.description',
    },
    {
      icon: 'assets/images/services/devops-and-automation.png',
      title: 'services-page.services.cyberSecurity.title',
      description: 'services-page.services.cyberSecurity.description',
    },
    {
      icon: 'assets/images/services/security-and-compliance.png',
      title: 'services-page.services.projectManagement.title',
      description: 'services-page.services.projectManagement.description',
    },
    {
      icon: 'assets/images/services/software-dev.png',
      title: 'services-page.services.appEngineering.title',
      description: 'services-page.services.appEngineering.description',
    },
    {
      icon: 'assets/images/services/tech-advisory.jpeg',
      title: 'services-page.services.techAdvisory.title',
      description: 'services-page.services.techAdvisory.description',
    },
    {
      icon: 'assets/images/services/emaildomain-db-hosting.jpeg',
      title: 'services-page.services.hosting.title',
      description: 'services-page.services.hosting.description',
    },
    {
      icon: 'assets/images/services/infra-and-network.jpeg',
      title: 'services-page.services.infrastructure.title',
      description: 'services-page.services.infrastructure.description',
    },
    {
      icon: 'assets/images/services/cloud-computing.jpeg',
      title: 'services-page.services.cloudAnalytics.title',
      description: 'services-page.services.cloudAnalytics.description',
    },
  ];
}
